import React from 'react'
import { Box, Card, CardContent, Typography } from '@mui/material'
import { TrendingUp, TrendingDown } from '@mui/icons-material'
import { formatCurrency } from '../mockData'

export default function KPICard({ title, value, variation, variationLabel, icon, color, isPercentage }) {
    const isPositive = variation >= 0
    const displayValue = isPercentage ? `${value}%` : formatCurrency(value)

    return (
        <Card
            sx={{
                height: '100%',
                border: '1px solid #E2E8F0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                transition: 'box-shadow 0.2s ease, transform 0.2s ease',
                '&:hover': {
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    transform: 'translateY(-2px)',
                },
            }}
        >
            <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            variant="body2"
                            sx={{ color: '#64748B', fontWeight: 500, mb: 0.5 }}
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="h5"
                            sx={{ color: '#1E293B', fontWeight: 700, mb: 1 }}
                        >
                            {displayValue}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {isPositive ? (
                                <TrendingUp sx={{ fontSize: 16, color: '#22C55E' }} />
                            ) : (
                                <TrendingDown sx={{ fontSize: 16, color: '#EF4444' }} />
                            )}
                            <Typography
                                variant="caption"
                                sx={{
                                    color: isPositive ? '#22C55E' : '#EF4444',
                                    fontWeight: 600,
                                }}
                            >
                                {isPositive ? '+' : ''}{variation}%
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#94A3B8' }}>
                                {variationLabel}
                            </Typography>
                        </Box>
                    </Box>
                    {icon && (
                        <Box
                            sx={{
                                width: 44,
                                height: 44,
                                borderRadius: '12px',
                                bgcolor: color ? `${color}15` : '#3B82F615',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: color || '#3B82F6',
                            }}
                        >
                            {icon}
                        </Box>
                    )}
                </Box>
            </CardContent>
        </Card>
    )
}
